<template lang="html">
  <div class="center-screen">
    <b-row>
      <b-col cols="12">
        <h1 class="title">Esperamos verte pronto</h1>
      </b-col>
      <b-col cols="12">
        <p class="body-text">Puedes volver a unirte a BrandMe cuando lo desees</p>
      </b-col>
      <b-col cols="12" class="d-flex align-items-center justify-content-center">
        <a href="/">
          <b-button variant="primary" class="button mt-3 mb-1">Volver al Inicio</b-button>
        </a>
      </b-col>
      <b-col cols="12">
        <b-img
          src="@/assets/images/good-bye.png"
          alt="Adiós"
          height="550"
          width="550"
        />
      </b-col>
    </b-row>
  </div>
</template>
 
<script lang="js">
import {
  BImg, BButton, BRow, BCol
} from 'bootstrap-vue'
export default  {
  name: 'GoodBye',
  props: {},
  components: {
    BImg,
    BButton,
    BRow,
    BCol
  },
  mounted() {
  },
  data() {
    return {
    }
  },
  methods: {
  },
  computed: {
  }
}
</script>
<style>
  .center-screen {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    min-height: 100vh;
  }

  .title {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 29px;
  }

  .body-text {
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 21px;
  }
</style>